
import { Component, Mixins } from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import { MasrafCesidi } from "@/enum/MasrafCesidi";

@Component({
  components: {Tutar, Dates, FormWrapper },
})
export default class MasrafCesitleriForm extends Mixins(ObjectInputMixin) {
  get isReadOnly(): boolean {
    const id = Number(this.localValue?.id);
    return id === MasrafCesidi.dosyamasrafi
        || id === MasrafCesidi.tebligatgideri
        || id === MasrafCesidi.barovekaletpulu;
  }
}
